module.exports = __webpack_public_path__ + "static/media/medmalIcon.d1d2d082.svg";